import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createTaskTemplateParameter = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
          mutation createTaskTemplateParameter($taskTemplateId: Int!, $name: String!, $description: String, $parameterType: String!, $required: Boolean!, $parameterData: String) {
            createTaskTemplateParameter(taskTemplateId: $taskTemplateId, name: $name, description: $description, parameterType: $parameterType, required: $required, parameterData: $parameterData) { id name description parameterType required parameterData createdAt updatedAt message error lowLevelErrorMessage }
          }
        `),
      variables: { taskTemplateId: data.taskTemplateId, name: data.name, description: data.description, parameterType: data.parameterType, required: data.required, parameterData: data.parameterData }
    })
  return response.data.createTaskTemplateParameter
}

export const updateTaskTemplateParameter = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
          mutation updateTaskTemplateParameter($id: Int!, $name: String!, $description: String, $parameterType: String!, $required: Boolean!, $parameterData: String) {
            updateTaskTemplateParameter(id: $id, name: $name, description: $description, parameterType: $parameterType, required: $required, parameterData: $parameterData) { id name description parameterType required parameterData createdAt updatedAt message error lowLevelErrorMessage }
          }
        `),
      variables: { id: data.id, name: data.name, description: data.description, parameterType: data.parameterType, required: data.required, parameterData: data.parameterData }
    })
  return response.data.updateTaskTemplateParameter
}

export const deleteTaskTemplateParameter = async (paramId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
          mutation deleteTaskTemplateParameter($id: Int!) {
            deleteTaskTemplateParameter(id: $id) { message error }
          }
        `),
      variables: { id: paramId }
    })
  return response.data.deleteTaskTemplateParameter
}
